<template>
  <checkout-panel
    index="3"
    title="Payment method"
    :editing="componentState.payment.editing"
    @handleEditing="handleEditing"
  >
    <template #main>
      <div v-if="selectedPaymentMethod">
        <div style="margin-top: 0.5rem">
          <checkout-payment-method-view
            :card="selectedPaymentMethod"
          ></checkout-payment-method-view>
        </div>
      </div>
      <h6 v-else>
        <span v-if="netTermsPayments">Net Terms Selected</span>
        <span v-else>No payment method selected</span>
      </h6>
    </template>
    <template #secondary>
      <loading-component
        v-if="componentState.payment.loading"
      ></loading-component>
      <checkout-add-payment-method
        v-else-if="addPayment"
        @toggleAddPayment="toggleAddPayment"
      ></checkout-add-payment-method>
      <checkout-change-payment-method
        v-else
        @addPayment="toggleAddPayment"
      ></checkout-change-payment-method>
    </template>
  </checkout-panel>
</template>

<script>
import { mapGetters } from "vuex";
import store from "../../../store/stores";
import CheckoutPanel from "../layout/CheckoutPanel.vue";
import CheckoutChangePaymentMethod from "./payment/CheckoutChangePaymentMethod.vue";
import CheckoutPaymentMethodView from "./payment/CheckoutPaymentMethodView.vue";
import CheckoutAddPaymentMethod from "./payment/CheckoutAddPaymentMethod.vue";
import LoadingComponent from "./elements/LoadingComponent.vue";

export default {
  store,
  components: {
    LoadingComponent,
    CheckoutAddPaymentMethod,
    CheckoutPaymentMethodView,
    CheckoutChangePaymentMethod,
    CheckoutPanel,
  },
  data() {
    return {
      addPayment: false,
    };
  },
  computed: {
    ...mapGetters({
      selectedPaymentMethod: "checkout/paymentMethod",
      componentState: "checkout/componentState",
      netTermsPayments: "checkout/netTermsPayments",
    }),
  },
  methods: {
    handleEditing() {
      this.$store.commit("checkout/SET_EDITING", {
        componentName: "payment",
        boolVal: !this.componentState.payment.editing,
      });
    },
    toggleAddPayment() {
      this.addPayment = !this.addPayment;
    },
  },
};
</script>
